import { getUnprojectedVisibility } from '@webview-native-ui/engine';
const intersectRects = (left, right) => {
    const x = Math.max(left.x, right.x);
    const y = Math.max(left.y, right.y);
    const maxX = Math.min(left.x + left.width, right.x + right.width);
    const maxY = Math.min(left.y + left.height, right.y + right.height);
    return {
        x,
        y,
        width: Math.max(0, maxX - x),
        height: Math.max(0, maxY - y),
    };
};
const toNativeRect = (rect) => ({
    x: rect.left,
    y: rect.top,
    width: rect.width,
    height: rect.height,
});
const clipsDescendants = (element) => {
    const style = window.getComputedStyle(element);
    return [style.overflow, style.overflowX, style.overflowY].some((value) => ['auto', 'hidden', 'scroll', 'clip'].includes(value));
};
export function* nativeAdAncestors(element) {
    var _a, _b;
    let current = element;
    while (current) {
        const root = current.getRootNode();
        current =
            (_b = (_a = current.assignedSlot) !== null && _a !== void 0 ? _a : current.parentElement) !== null && _b !== void 0 ? _b : (root instanceof ShadowRoot ? root.host : null);
        if (current)
            yield current;
    }
}
export const measureNativeAdSlot = (element, scrollElement) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const style = window.getComputedStyle(element);
    const domRect = element.getBoundingClientRect();
    if (!element.isConnected ||
        style.display === 'none' ||
        (style.visibility === 'hidden' && getUnprojectedVisibility(element) === 'hidden') ||
        Number.parseFloat(style.opacity || '1') === 0 ||
        domRect.width <= 0 ||
        domRect.height <= 0) {
        return undefined;
    }
    const rect = toNativeRect(domRect);
    let clipRect = scrollElement
        ? rect
        : {
            x: (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.offsetLeft) !== null && _b !== void 0 ? _b : 0,
            y: (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.offsetTop) !== null && _d !== void 0 ? _d : 0,
            width: (_f = (_e = window.visualViewport) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : window.innerWidth,
            height: (_h = (_g = window.visualViewport) === null || _g === void 0 ? void 0 : _g.height) !== null && _h !== void 0 ? _h : window.innerHeight,
        };
    let foundScrollElement = !scrollElement;
    for (const ancestor of nativeAdAncestors(element)) {
        if (ancestor === scrollElement) {
            foundScrollElement = true;
            break;
        }
        if (clipsDescendants(ancestor)) {
            clipRect = intersectRects(clipRect, toNativeRect(ancestor.getBoundingClientRect()));
        }
    }
    clipRect = intersectRects(rect, clipRect);
    if (!foundScrollElement || clipRect.width <= 0 || clipRect.height <= 0)
        return undefined;
    if (scrollElement) {
        const origin = scrollElement.getBoundingClientRect();
        const translate = (value) => (Object.assign(Object.assign({}, value), { x: value.x - origin.left + scrollElement.scrollLeft, y: value.y - origin.top + scrollElement.scrollTop }));
        return { rect: translate(rect), clipRect: translate(clipRect) };
    }
    return { rect, clipRect };
};
export const measureNativeAdScrollContainer = (element) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const rect = toNativeRect(element.getBoundingClientRect());
    let clipRect = intersectRects(rect, {
        x: (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.offsetLeft) !== null && _b !== void 0 ? _b : 0,
        y: (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.offsetTop) !== null && _d !== void 0 ? _d : 0,
        width: (_f = (_e = window.visualViewport) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : window.innerWidth,
        height: (_h = (_g = window.visualViewport) === null || _g === void 0 ? void 0 : _g.height) !== null && _h !== void 0 ? _h : window.innerHeight,
    });
    for (const ancestor of nativeAdAncestors(element)) {
        if (clipsDescendants(ancestor)) {
            clipRect = intersectRects(clipRect, toNativeRect(ancestor.getBoundingClientRect()));
        }
    }
    return { rect, clipRect, contentWidth: element.scrollWidth, contentHeight: element.scrollHeight };
};
//# sourceMappingURL=native-ad-geometry.js.map